import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Component({
  selector: 'app-search-by-location',
  templateUrl: './search-by-location.component.html',
  styleUrls: ['./search-by-location.component.css']
})
export class SearchByLocationComponent implements OnInit {

  location = '';
  latitude?: number;
  longitude?: number;
  country = '';

  options = {
    fields: ['name', 'geometry.location', 'address_components', 'formatted_address']
  };

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  public handleAddressChange(address: Address) {
    this.latitude = address.geometry.location.lat();
    this.longitude = address.geometry.location.lng();
    this.location = address.formatted_address;
    const filtered_array = address?.address_components?.filter(function (address_component) {
      return address_component.types.includes('country');
    });
    this.country = filtered_array?.length ? filtered_array[0].long_name : '';
  }

  search(): void {
    if (!this.location) {
      return;
    }
    this.router.navigate(['/search-results-location'], {
      queryParams: {
        q: this.location,
        lat: this.latitude,
        lng: this.longitude,
        country: this.country
      }
    });
  }

  clearSearch(): void {
    this.location = '';
    this.latitude = undefined;
    this.longitude = undefined;
    this.country = '';
  }
}
